'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import {
  borderStyles,
  coloringStyles,
  flexItemStyles,
  layoutStyles,
  marginStyles,
  sizingStyles
} from '../../_support'

// lib
import { themedView } from '../../_support'

/* -----------------------------------------------------------------------------
 * InputContainer
 * -------------------------------------------------------------------------- */

export const ThemedInputContainer = themedView(
  'InputContainer',
  coloringStyles,
  borderStyles,
  flexItemStyles,
  layoutStyles,
  marginStyles,
  sizingStyles
)

export type ThemedInputContainerProps = React.ComponentProps<
  typeof ThemedInputContainer
>

export type InputContainerProps = ThemedInputContainerProps & {}

const InputContainer = (props: InputContainerProps) => {
  return <ThemedInputContainer style={{ overflow: 'hidden' }} {...props} />
}

export default InputContainer
